import styled, { css } from 'styled-components';
import { media, fontSize } from 'settings/style';
import { Button } from 'components/elements';

export const FooterWrapper = styled.footer`
  background: #020406;
  color: #f4f6f8;
  margin-top: 24px;

  a {
    color: inherit;
    text-decoration: none;
  }
`;

export const ContentGrid = styled.div`
  padding: 64px 0 54px;
  display: grid;
  gap: 42px;
  grid-template-columns: minmax(0, 2.1fr) minmax(240px, 0.95fr) minmax(0, 1.15fr);
  align-items: center;

  ${media.md`
    grid-template-columns: 1fr;
    justify-items: center;
  `}

  ${media.xs`
    padding: 24px 0 34px;
    gap: 28px;
  `}
`;

export const InfoTitle = styled.h3`
  margin: 0;
  color: #f3f2ef;
  line-height: 1.08;
  font-family: Georgia, 'Times New Roman', serif;
  font-weight: 500;
  font-size: ${fontSize.xxl};

  ${media.xs`
    font-size: 30px;
  `}
`;

export const InfoDescription = styled.p`
  margin: 18px 0 0;
  max-width: 760px;
  color: #a7b0bf;
  font-size: ${fontSize.md};
  line-height: 1.5;

  ${media.xs`
    font-size: 16px;
  `}
`;

export const ContactRow = styled.div`
  margin-top: 26px;
  display: flex;
  gap: 34px;
  align-items: center;
  flex-wrap: wrap;

  ${media.xs`
    gap: 14px;
  `}
`;

export const ContactItem = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #c7cdd8;
  font-size: 16px;

  .anticon {
    color: #95a1b3;
    font-size: 18px;
  }

  strong {
    color: #fbfbfd;
    font-weight: 600;
  }

  ${media.xs`
    font-size: 15px;
    gap: 8px;

    .anticon {
      font-size: 16px;
    }
  `}
`;

export const DonationPanel = styled.section`
  justify-self: end;

  ${media.md`
    justify-self: start;
  `}

  ${media.xs`
    width: 100%;
  `}
`;

export const DonationButton = styled(Button)`
  height: 50px;
  min-width: 240px;
  border-radius: 12px;
  border: none;
  font-size: 18px;
  font-weight: 700;
  background: #f2b300;
  color: #2f2400;
  box-shadow: none;

  &:hover,
  &:focus {
    background: #ffd04f;
    color: #2f2400;
  }

  ${media.xs`
    width: 100%;
  `}
`;

export const PaymentRow = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  color: #b4bcc9;
  font-size: 16px;

  ${media.md`
    justify-content: flex-start;
  `}

  ${media.xs`
    flex-wrap: wrap;
  `}
`;

export const PaymentIcons = styled.div`
  display: flex;
  gap: 12px;
`;

export const PaymentChip = styled.span`
  width: 54px;
  height: 42px;
  border-radius: 10px;
  background: #eef2f5;
  color: #1f2531;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
`;

export const BottomBar = styled.div`
  border-top: 1px solid #161b22;
  padding: 20px 0 24px 0px;
  
  ${media.md`
    padding: 20px 0 80px 0px;
  `}
`;

export const BottomContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 26px;

  ${media.md`
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const BrandLogo = styled.a<{ mobileShow?: boolean }>`
  display: ${({ mobileShow }) => (mobileShow ? 'none' : 'inline-flex')};
  align-items: center;

  img {
    width: 240px;
    max-width: 100%;
  }

  ${({ mobileShow }) => mobileShow && css`
    ${media.xs`
      display: inline-flex;
    `}
  `}

  ${({ mobileShow }) => !mobileShow && css`
    ${media.xs`
      display: none;
    `}
  `}
`;

export const LegalLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  color: #8d96a7;
  font-size: 16px;

  a {
    color: #b8c0cf;
    position: relative;
  }

  a + a {
    padding-left: 14px;

    &:before {
      content: '|';
      position: absolute;
      left: -4px;
      color: #667085;
    }
  }

  ${media.xs`
    flex-wrap: wrap;
    gap: 8px;
    font-size: 14px;

    a + a {
      padding-left: 10px;

      &:before {
        left: -3px;
      }
    }
  `}
`;
